import { useState } from "react";
import { FieldArrayWithId, useFieldArray, useFormContext } from "react-hook-form";

// Redux

// Services
import { getTranslateByKey, isNullUndefinedEmpty } from "@/main/services/utils";

// Types
import { DynamicReportForm, DynamicReportVariableForm } from "../../registerDynamicReport";

// Api

// Components
import KOGSection from "@/main/components/shared/kogSection/kogSection";
import NewVariable from "./newVariable/newVariable";
import VariableList from "./variableList/variableList";

function VariablesSection() {
	const [variableToEdit, setVariableToEdit] = useState<FieldArrayWithId<DynamicReportForm, "variables", "id"> | null>(
		null,
	);

	const { control } = useFormContext<DynamicReportForm>();

	const { fields, append, replace } = useFieldArray<DynamicReportForm, "variables">({ control, name: "variables" });

	function addNew(newVariable: DynamicReportVariableForm) {
		const currentMax = fields.reduce((max, current) => {
			if (current.ordering > max) return current.ordering;
			return max;
		}, 0);
		newVariable.ordering = currentMax + 1;
		append(newVariable);
	}

	function startEdit(variable: FieldArrayWithId<DynamicReportForm, "variables", "id">) {
		setVariableToEdit(variable);
	}

	function finishEdit(updatedVariable: DynamicReportVariableForm | null) {
		if (!variableToEdit) return;

		if (updatedVariable) {
			const index = fields.findIndex((field) => field.id == variableToEdit.id);
			if (index > -1) {
				fields[index] = { ...updatedVariable, id: fields[index].id };
				replace(fields);
			}
		}
		setVariableToEdit(null);
	}

	function removeVariable(variable: FieldArrayWithId<DynamicReportForm, "variables", "id">) {
		const updatedFields = fields
			.filter((field) => field.id != variable.id)
			.map((field) => {
				if (field.ordering > variable.ordering) field.ordering -= 1;
				return field;
			});
		replace(updatedFields);
	}

	//used to validate duplicated names
	const usedVariablesNames = fields
		.filter((field) => !variableToEdit || field.id != variableToEdit.id)
		.flatMap((field) => {
			const names = [field.variableName];
			if (!isNullUndefinedEmpty(field.variableRangeName)) names.push(field.variableRangeName);
			return names;
		});

	const usedFilterNames = fields
		.filter((field) => !variableToEdit || field.id != variableToEdit.id)
		.flatMap((field) => field.filterName);

	return (
		<KOGSection title={getTranslateByKey("information.filters")}>
			<NewVariable
				variableToEdit={variableToEdit as DynamicReportVariableForm}
				usedVariableNames={usedVariablesNames}
				usedFilterNames={usedFilterNames}
				finishEdit={finishEdit}
				addNew={addNew}
			/>
			{!!fields && fields.length > 0 && (
				<VariableList fields={fields} replace={replace} startEdit={startEdit} remove={removeVariable} />
			)}
		</KOGSection>
	);
}

export default VariablesSection;
